export const settings = {
    appName: config.appName,
    appUrl: config.appUrl,
    apiUrl: config.apiUrl,
    facebook: config.facebook,
    google: config.google,
    apple: config.apple,

    ios: config.ios,
    android: config.android,
    mobile_app: config.mobile_app || {},
    update: config.update || {},
    device: config.device,
    name: config.name,
    version: config.version,
    build: config.build,
    ios_id: config.ios_id,
    device_uid: config.device_uid,
    device_uid_source: config.device_uid_source,
    dev_api: config.dev_api,
    fcm_token: config.fcm_token,
    onesignal_user_id: config.onesignal_user_id,
    onesignal_app_id: config.onesignal_app_id,
    onesignal_enabled: config.onesignal_enabled,
    onesignal_web_enabled: config.onesignal_web_enabled,
    is_native_app: config.is_native_app === true || config.is_native_app === 'true',
    web_integrations: config.web_integrations || {}
};
